<template>
  <div class="sport-series-container">
    <div class="sport-series-content">
      <!-- 筛选区域 -->
      <div :class="{'filter-area': true}">
        <div class="filter-left">
          <div @click="backToSeriesList" v-if="viewMode != 'series'" class="back"></div>
          <p v-if="viewMode != 'series'">{{currentSeries.series_title}}</p>
          <div v-if="viewMode === 'series'" class="filter-item">
            <label>标题</label>
            <input type="text" v-model="searchTitle" placeholder="请输入标题" class="filter-input" @keyup.enter="handleSearch" />
          </div>
          <div v-if="viewMode === 'series'" class="filter-item">
            <label class="alert">栏目</label>
            <el-select v-model="searchColumn" placeholder="请选择栏目" clearable>
              <el-option
                v-for="item in columnOptions"
                :key="item.column_key"
                :label="item.name"
                :value="item.column_key"
              />
            </el-select>
          </div>
          <div v-if="viewMode === 'series'" class="filter-item">
            <label>播出时间</label>
            <date-picker
              :type="'date'"
              :format="'YYYY-MM-DD'"
              v-model="datePicker"
              range
              placeholder="  开始时间  ~  结束时间"
              calendar-icon="none"
              :editable="false"
              :clearable="true"
              :shortcuts="false"
              confirm
            />
          </div>
        </div>
        <div class="filter-right">
          <!-- <button v-if="viewMode === 'manuscript'" class="btn back-btn" @click="backToSeriesList">
            <i></i>
            <span>返回</span>
          </button> -->
          <button v-if="viewMode === 'series'" class="btn clear-btn" @click="clearFilters">
            <i></i>
            <span>清空</span>
          </button>
          <button v-if="viewMode === 'series'" class="btn greenBtn search-btn" @click="handleSearch">
            <i></i>
            <span>查询</span>
          </button>
        </div>
      </div>

      <!-- 串联单列表 -->
      <template v-if="viewMode === 'series'">
        <div v-if="seriesList.length" class="data-table">
          <div class="headContainer">
            <div class="col-index">序号</div>
            <div class="col-series-title">标题</div>
            <div class="col-series-column">栏目</div>
            <div class="col-series-editor">主编</div>
            <div class="col-series-date">拟播日期</div>
            <div class="col-series-status">播出状态</div>
          </div>
          <ul class="tableContainer">
            <li v-for="(item, index) in seriesList" :key="index" @click="enterManuscriptList(item)" class="series-row">
              <div class="col-index">{{ (page.pageIndex - 1) * page.pageSize + index + 1 }}</div>
              <div class="col-series-title" :title="item.title">{{ item.series_title }}</div>
              <div class="col-series-column">{{ item.column_title }}</div>
              <div class="col-series-editor">{{ item.series_editor }}</div>
              <div class="col-series-date">{{ item.broadcast_time }}</div>
              <div class="col-series-status">
                <span :class="['status-tag']">{{ item.series_broadcast_status }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="seriesList.length == 0" class="empty-state">
          <div>
            <img src="../../assets/img/sportSeriesList/empty.png" alt="empty.png">
            <p>暂无串联单数据，请进行筛选后搜索</p>
          </div>
        </div>
        <div class="pagination-container">
          <pages :page_count="seriesPage.pageCount" :index="seriesPage.pageIndex" :total="seriesPage.total" />
        </div>
      </template>

      <!-- 文稿列表 -->
      <template v-if="viewMode === 'manuscript'">
        <div v-if="list.length" class="data-table">
          <div class="headContainer">
            <div class="col-index">序号</div>
            <div class="col-title">标题</div>
            <div class="col-method">播出方式</div>
            <div class="col-duration">导语时长</div>
            <div class="col-duration">视频时长</div>
            <div class="col-duration">总时长</div>
            <div class="col-creator">创建人</div>
            <div class="col-status">文稿状态</div>
            <div class="col-status">栏目状态</div>
            <div class="col-time">播出时间</div>
          </div>
          <ul class="tableContainer">
            <li v-for="(item, index) in list" :key="index">
              <div class="col-index">{{ (page.pageIndex - 1) * page.pageSize + index + 1 }}</div>
              <div @click="toDetail(item.doc_id, item.can_click)" class="col-title" :class="{'col-title--disabled': !item.can_click}" :title="item.title">{{ item.title }}</div>
              <div class="col-method">{{ item.broadcast_type }}</div>
              <div class="col-duration">{{ item.guide_duration }}</div>
              <div class="col-duration">{{ item.video_duration }}</div>
              <div class="col-duration">{{ item.total_duration }}</div>
              <div class="col-creator">{{ item.created_username }}</div>
              <div class="col-status">
                <span :class="['status-tag']">{{ item.document_status }}</span>
              </div>
              <div class="col-status">
                <span :class="['status-tag']">{{ item.program_status }}</span>
              </div>
              <div class="col-time">{{ item.broadcast_time }}</div>
            </li>
          </ul>
        </div>
        <div v-if="list.length == 0" class="empty-state">
          <div>
            <img src="../../assets/img/sportSeriesList/empty.png" alt="empty.png">
            <p>暂无报片数据，请进行筛选后搜索</p>
          </div>
        </div>
        <div class="pagination-container">
          <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import pages from "@components/pages";
import common from "@common/common";
import { apis } from "@common/config";
import DatePicker from 'vue2-datepicker';

export default {
  name: "SportSeriesList",
  components: {
    pages,
    DatePicker
  },
  data() {
    return {
      viewMode: "series",
      searchTitle: "",
      datePicker: "",
      start: "",
      end: "",
      searchColumn: "",
      columnOptions: [],
      currentSeries: null,
      seriesList: [],
      seriesPage: {
        pageCount: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      list: [],
      page: {
        pageCount: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      }
    };
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n) {
        if (n && n[0]) {
          this.start = common.stampToDate(n[0]);
          this.end = common.stampToDate(n[1]);
        } else {
          this.start = "";
          this.end = "";
        }
      }
    }
  },
  mounted() {
    this.getColumnList();
    // this.getSeriesList();
  },
  methods: {
    toDetail(id, can_click){
      if(!can_click) return
      common.jumpOut(
        `/unifiedContentLibrary/content/doc/detail/${id}`
      );
    },
    getStatusClass(status) {
      if (!status) return '';
      var map = {
        '已通过': 'status-green',
        '已审核': 'status-green',
        '已完成': 'status-green',
        '通过': 'status-green',
        '待审核': 'status-yellow',
        '审核中': 'status-yellow',
        '草稿': 'status-gray',
        '未提交': 'status-gray',
        '已驳回': 'status-red',
        '驳回': 'status-red'
      };
      return map[status] || 'status-gray';
    },
    getColumnList() {
      common.myFetch(apis.sport_series_column_list, {}).then(function(res) {
        if (res) {
          this.columnOptions = res || [];
        }
      }.bind(this));
    },
    getSeriesList() {
      var data = {
        page: this.seriesPage.pageIndex,
        pagesize: this.seriesPage.pageSize,
        title: this.searchTitle,
        start_time: this.start,
        end_time: this.end,
        column_key: this.searchColumn
      };

      common.myFetch(apis.sport_series_program_list, { data: data }).then(function(res) {
        if (res) {
          this.seriesList = res.list || [];
          this.$set(this.seriesPage, "pageCount", res.page.page_count);
          this.$set(this.seriesPage, "total", res.page.row_count - 0);
        }
      }.bind(this));
    },
    enterManuscriptList(series) {
      this.currentSeries = series;
      this.currentSeries.searchTitle = this.searchTitle
      this.viewMode = "manuscript";
      this.page.pageIndex = 1;
      this.searchTitle = ''
      this.getList();
    },
    backToSeriesList() {
      this.searchTitle = this.currentSeries.searchTitle
      this.viewMode = "series";
      this.currentSeries = null;
      this.list = [];
    },
    getList() {
      if (this.viewMode === 'series') {
        this.seriesPage.pageIndex = this.page.pageIndex;
        this.getSeriesList();
        return;
      }
      if (!this.currentSeries) return;

      var data = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        title: this.searchTitle,
        series_id: this.currentSeries.series_id,
        column_key: this.currentSeries.column_key
      };

      common.myFetch(apis.sport_series_list, { data: data }).then(function(res) {
        if (res) {
          this.list = res.list || [];
          this.$set(this.page, "pageCount", res.page.page_count);
          this.$set(this.page, "total", res.page.row_count - 0);
        }
      }.bind(this));
    },
    handleSearch() {
      if (this.viewMode === 'series') {
        this.seriesPage.pageIndex = 1;
        if(!this.searchColumn){
          this.$toast('栏目不能为空')
          return false
        }
        this.getSeriesList();
      } else {
        this.page.pageIndex = 1;
        this.getList();
      }
    },
    clearFilters() {
      if (this.viewMode === 'series') {
        this.searchTitle = "";
        this.datePicker = "";
        this.start = "";
        this.end = "";
        this.searchColumn = "";
        this.seriesPage.pageIndex = 1;
        // this.getSeriesList();
      } else {
        this.searchTitle = "";
        this.page.pageIndex = 1;
        this.getList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sport-series-container {
  padding: 20px;
  flex: 1;
  min-width: 0;

  .sport-series-content {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 4px;
    height: 100%;

    // 页面头部
    .page-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 30px;
      border-bottom: 1px solid #f0f0f0;

      .header-left {
        .page-title {
          font-size: 18px;
          font-weight: bold;
          color: #050F0F;
        }
      }

      .header-right {
        .add-btn {
          width: 120px;
          height: 40px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    .filter-area {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 30px 10px;
      box-sizing: border-box;

      .back {
        display: block;
        width: 30px;
        min-width: 30px;
        height: 30px;
        background: url('../../assets/img/sportSeriesList/back.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-right: 10px;
        margin-bottom: 20px;
        user-select: none;
        cursor: pointer;
      }

      .filter-left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        p {
          margin-bottom: 20px;
        }

        .filter-item {
          display: flex;
          align-items: center;
          margin: 0 60px 20px 0;

          label {
            font-weight: bold;
            font-size: 13px;
            color: #829191;
            white-space: nowrap;
            width: 52px;
            margin-right: 30px;
            text-align: justify;
            text-align-last: justify;

            &.alert {
              position: relative;

              &::before {
                position: absolute;
                top: 0;
                left: -10px;
                display: block;
                content: '*';
                color: #FF4D4D;
              }
            }
          }

          .el-select {
            width: 320px;
            height: 30px;
            box-sizing: border-box;
            border-radius: 4px;
            font-size: 14px;
            outline: none;
          }

          .filter-input {
            width: 320px;
            height: 30px;
            border: 1px solid #dcdcdc;
            box-sizing: border-box;
            border-radius: 4px;
            padding: 0 12px;
            font-size: 14px;
            outline: none;

            &::placeholder {
              color: #c0c4cc;
            }

            &:focus {
              border-color: #41B48C;
            }
          }
        }
      }

      .filter-right {
        display: flex;
        gap: 10px;

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 40px;
          border-radius: 20px;
          cursor: pointer;
          user-select: none;
          font-size: 14px;

          &:active {
            background-color: rgba(0, 0, 0, 0.2);
          }

          &:hover {
            position: relative;

            &::after {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              border-radius: inherit;
              background-color: rgba(0, 0, 0, 0.05);
            }
          }
        }

        .clear-btn {
          border: 1px solid #41B48C;
          background-color: #fff;
          color: #41B48C;

          i {
            display: block;
            width: 19px;
            height: 19px;
            background: url('../../assets/img/sportSeriesList/del.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 10px;
          }
        }

        .back-btn {
          border: 1px solid #dcdcdc;
          background-color: #fff;
          color: #050F0F;

          i {
            display: block;
            width: 19px;
            height: 19px;
            background: url('../../assets/img/sportSeriesList/back.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 10px;
          }
        }

        .greenBtn {
          background-color: #41B48C;
          color: #fff;
          border: none;

          i {
            display: block;
            width: 19px;
            height: 19px;
            background: url('../../assets/img/sportSeriesList/search.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 10px;
          }
        }
      }
    }

    .data-table {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-bottom: 30px;

      .headContainer {
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        box-shadow: 0px 0px 10px 0px rgba(6,21,50,0.05);
        padding: 0 30px;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 14px;
        color: #829191;
      }

      .tableContainer {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0 30px 0 20px;
        box-sizing: border-box;

        li {
          display: flex;
          align-items: center;
          width: 100%;
          min-height: 70px;
          font-weight: 400;
          font-size: 14px;
          color: #050F0F;
          padding-left: 10px;
          box-sizing: border-box;
          border-bottom: 1px solid #f5f5f5;

          &.un {
            color: #829191;
          }

          &:hover {
            background: rgba(185, 195, 195, 0.15);

            .col-title {
              color: #41B48C;
            }
          }

          .col-index {
            font-size: 16px;
          }

          .col-title {
            font-size: 16px;
          }
        }
      }

      .col-index {
        width: 58px;
      }

      .series-row {
        cursor: pointer;
      }

      .col-series-title {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 33px;
      }

      .col-series-column {
        width: 120px;
        margin-right: 40px;
        text-align: center;
      }

      .col-series-editor {
        width: 80px;
        margin-right: 40px;
        text-align: center;
      }

      .col-series-date {
        width: 120px;
        margin-right: 40px;
        text-align: center;
      }

      .col-series-status {
        width: 80px;
        text-align: center;
      }

      .col-title {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 33px;
        cursor: pointer;

        &--disabled {
          color: #999 !important;
          cursor: not-allowed;
        }
      }

      .col-method {
        width: 56px;
        margin-right: 52px;
        text-align: center;
      }

      .col-duration {
        width: 56px;
        margin-right: 50px;
        text-align: center;
      }

      .col-creator {
        width: 42px;
        margin-right: 50px;
        text-align: center;
      }

      .col-status {
        width: 56px;
        margin-right: 50px;
        text-align: center;
      }

      .col-time {
        width: 79px;
      }

      // 状态标签样式
      .status-tag {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        min-width: 56px;
        height: 24px;
        padding: 0 10px;
        border-radius: 12px;
        font-size: 12px;
        white-space: nowrap;
      }

      .status-green {
        background: rgba(24, 198, 139, 0.15);
        color: #18C68B;
      }

      .status-yellow {
        background: rgba(255, 171, 0, 0.15);
        color: #E6A000;
      }

      .status-gray {
        background: rgba(185, 195, 195, 0.15);
        color: #829191;
      }

      .status-red {
        background: rgba(255, 77, 77, 0.15);
        color: #FF4D4D;
      }
    }

    .empty-state {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      flex: 1;
      min-height: 0;
      font-weight: 400;
      font-size: 16px;
      color: #B9C3C3;
      line-height: 22px;
      padding: 0 30px;
      box-sizing: border-box;

      div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-top: 2px solid #DCDCDC;
        box-sizing: border-box;
      }

      img {
        width: 94px;
        height: 71px;
        margin-bottom: 21px;
      }
    }

    .pagination-container {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
}
</style>

<style lang="less">
.sport-series-content {
  .el-select {
    .el-input {
      width: 100%;
      height: 100%;
      input {
        width: 100%;
        height: 100%;
      }

      &.is-focus {
        .el-input__inner {
          border-color: #41B48C;
        }
      }

      .el-select__caret {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
